import { CSSProperties } from "react";
import Star from "./Star";

type Props = {
  id: string;
  rating: number;
};

export default function Stars({ id, rating }: Props) {
  const TOTAL_STARS = 5;
  const STARS_ARRAY = [...Array(TOTAL_STARS)];

  const calculateFillPercentage = (rating: number, index: number): number => {
    return Math.max(
      0,
      Math.min(100, rating >= index + 1 ? 100 : (rating - index) * 100),
    );
  };

  const styles: CSSProperties = { display: "flex", gap: "var(--spacing-2xs)" };

  return (
    <div style={styles}>
      {STARS_ARRAY.map((_, index) => {
        return (
          <Star
            key={index}
            id={id}
            index={index}
            fillPercentage={calculateFillPercentage(rating, index)}
          />
        );
      })}
    </div>
  );
}
